import State from 'store/State';
import { selectComponentKeysByType } from 'layout/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectFillsGraphWidgetKeys: (state: State) => string[] = (state) =>
    selectComponentKeysByType(state, WidgetType.FILLS_GRAPH);

export const selectFillsGraphsWidgetsState = (state: State) =>
    selectWidgetInstancesState(state).fillsGraph;

export const selectFillsGraphState = (state: State, fillsGraphId: string) =>
    selectFillsGraphsWidgetsState(state)[fillsGraphId];
